module.exports = __webpack_public_path__ + "static/assets/c947aa0e17eb7448a51158d6a0c8091d.png";